import format from 'date-fns/format'; // tslint:disable-line:no-submodule-imports
import React from 'react';
import SEO from '../components/seo';
import { ContentfulBlogPost } from '../graphql';

interface Props {
  data: {
    contentfulBlogPost: ContentfulBlogPost;
  };
}

const PostTemplate: React.SFC<Props> = ({ data }) => {
  const { contentfulBlogPost: post } = data;
  return (
    <>
      <SEO
        pageData={{
          title: post.title,
          description: post.description,
          url: post.fields.url,
          datePublished: post.fields.publishedDate,
        }}
        isBlogPost
      />
      <article className="mb-8 post">
        <div className="mb-4">
          <h1 className="mt-0 mb-4 text-black">{post.title}</h1>
        </div>
        <time
          dateTime={post.fields.publishedDate}
          className="block -mt-2 mb-4 pt-2 border-t border-dotted border-grey"
        >
          {format(post.fields.publishedDate, 'D MMMM YYYY')}
        </time>
        <div
          dangerouslySetInnerHTML={{
            __html: post.body.childMarkdownRemark.html,
          }}
        />
      </article>
    </>
  );
};

export default PostTemplate;

export const pageQuery = graphql`
  query blogPostQuery($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      body {
        childMarkdownRemark {
          html
        }
      }
      description
      title
      slug
      backDate
      tags
      fields {
        url
        publishedDate
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/post.tsx